import { GET_SETTINGS_DATA } from './../constants/actionTypes'

const settings = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_SETTINGS_DATA:
      // TODO: get alertCode from config
      return action.data.data
    default:
      return store
  }
}

export default settings
